import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchScore } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useAcknowledgeKeepInTouchScore = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchScore) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (scoreId: string) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchScore>(
				`KeepInTouchJobConfiguration/scores/${scoreId}/acknowledge`,
				'PUT',
				null
			);
		},
		onError,
		onSuccess,
	});
};
